module.exports = __webpack_public_path__ + "img/promo-1.0627e1d2.jpeg";